import {Feature} from 'types/feature';
import {CloudAppUser} from 'types/store';

export const isFeatureDisabled = (user: CloudAppUser, feature: Feature) =>
  user.disabledFeatures.includes(feature);
